<template>
  <div id="app">
    <HomeComponents/>
    <DualCoreComponents/>
    <PlatformCapabilitiesComponents/>
    <ContactsComponents/>
  </div>
</template>

<script>
import HomeComponents from './components/HomeComponents.vue'
import DualCoreComponents from './components/DualCoreComponents.vue'
import PlatformCapabilitiesComponents from './components/PlatformCapabilitiesComponents.vue'
import ContactsComponents from './components/ContactsComponents.vue'

export default {
  name: 'app',
  components: {
      HomeComponents,
      DualCoreComponents,
      PlatformCapabilitiesComponents,
      ContactsComponents
  }
}
</script>
